import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../primitives/Button";
import { Icon } from "../primitives/Icon";
import { t } from "../../i18n";
export function NotificationsToggle({ state, onEnable, onDisable, iconOnly = false, className, }) {
    const isOn = state === "subscribed";
    const disabled = state === "unsupported" || state === "denied";
    const label = state === "subscribed" ? t("topbar.alertsOn") :
        state === "denied" ? t("topbar.alertsBlocked") :
            state === "unsupported" ? t("topbar.alertsUnavailable") :
                t("topbar.enableAlerts");
    return (_jsx(Button, { variant: isOn ? "secondary" : "ghost", size: "sm", onClick: () => (isOn ? void onDisable() : void onEnable()), disabled: disabled, icon: _jsx(Icon, { name: isOn ? "bell" : disabled ? "bell-off" : "bell", size: "sm" }), "aria-label": label, "aria-pressed": isOn, className: className, children: !iconOnly && _jsx("span", { className: "hidden sm:inline", children: label }) }));
}
//# sourceMappingURL=NotificationsToggle.js.map